import { BaseService } from "@kiddocare-platform/portal-common/base";

export class PlatformAtlasService extends BaseService {

  /*public async GetElements(): Promise<AtlasElement | null> {
    try {
      const response = await this.AxiosInstance.get('/administrator/atlas/elements');
      return response.data.data;
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }*/

  public async GetElement(path: string): Promise<any | null> {
    try {
      const response = await this.AxiosInstance.get('/administrator/atlas/element/' + path, { responseType: 'blob' });
      return response.data;
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }

  public async GetScope(name: string): Promise<any | null> {
    try {
      const response = await this.AxiosInstance.get('/administrator/atlas/scope/' + name);
      return response.data;
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }

}